import styled from '@emotion/styled';

export const PricesExpandedColumnItem = styled.div`
  ${({ theme }) => theme.media.showAt({ to: 1 })`
    display: flex;
  `}
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    display: inline-flex;
    min-width: 0;
  `}
  ${({ theme }) => `
    margin-bottom: ${theme.spacing(1)};
    & > div:first-of-type {
      width: 80px;
      white-space: nowrap;
    }
    & > div:last-of-type {
      color: ${theme.colors.neutrals.grey3};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: calc(100% - 80px);
    }
  `}
`;

export const PricesTabsBodyWrapper = styled.div`
  padding-top: ${({ theme }) => theme.spacing(2)};
`;
